import React from "react"
import { assets, CheckboxTable, CheckboxTableColum, DatePicker, form2, Input, SelectSearch, sharedStyle, SortFieldInfo } from "@pulseops/common"
import { SectionCol, SectionContent, SectionRow } from "@pulseops/submission/common"
import { useTranslation } from "react-i18next"
import { StyleSheet, Text, ScrollView, TouchableOpacity, View } from "react-native"
import { APImportedFileDetailHistoryForm } from "./APApplyingPremiumForm"
import { Controller } from "react-hook-form"

export const APImportedFileDetailHistory = () => {
  const { t } = useTranslation()
  const [pageSize, setPageSize] = React.useState(10)
  const [pageNum, setPageNum] = React.useState(1)
  const [total, setTotal] = React.useState(0)
  const [sortItem, setSortItem] = React.useState<SortFieldInfo>({ field: '', order: 'asc' })
  const { base, handleSubmit } = form2.useForm(APImportedFileDetailHistoryForm.APImportedFileDetailHistoryC, {
    defaultValues: {
      fromDate: undefined,
      toDate: undefined,
      batchName: '',
      policyNumber: '',
      status: undefined,
      transactionID: ''
    }
  })
  const dataSource = [
    {
      transactionId: 'PC-09688224-8195-11f1-a91b-c215b114b75c	',
      policyNumber: 'Nguyen van A',
      amount: '700000000',
      transactionDate: '17/07/2026 - 11:07:40',
      status: 'Success'
    },
    {
      transactionId: 'PC-09688224-8195-11f1-a91b-c215b114b75c	',
      policyNumber: 'Nguyen van A',
      amount: '700000000',
      transactionDate: '17/07/2026 - 11:07:40',
      status: 'Success'
    },
  ]
  const displayedColumns: CheckboxTableColum[] = [
    {
      title: t('Transaction ID'),
      fieldName: 'transactionId'
    },
    {
      title: t('Policy Number'),
      fieldName: 'policyNumber'
    },
    {
      title: t('Amount'),
      fieldName: 'amount'
    },
    {
      title: t('Transaction Date'),
      fieldName: 'transactionDate',
    },
    {
      title: t('Status'),
      fieldName: 'status',
      disabled: true
    },
  ]
  const onSearchEvent = handleSubmit((formValues) => {
    console.log('formValues:', JSON.stringify(formValues))
  })
  return (
    <ScrollView style={sharedStyle.wrapper}>
      <SectionContent>
        <SectionRow>
          <SectionCol>
            <Controller
              control={base.control}
              name="batchName"
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <Input
                  title={t('BatchName')}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              )}
            />
          </SectionCol>
          <SectionCol>
            <Controller
              control={base.control}
              name="fromDate"
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <DatePicker
                  required={true}
                  label={t('ServiceInquiry:FromDate')}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  maxDate={new Date()}
                  maxDateMessage={t('message:MS990032')}
                  minDate={undefined}
                  minDateMessage={''}
                  errorMessage={error?.message}
                />
              )}
            />
          </SectionCol>
          <SectionCol>
            <Controller
              control={base.control}
              name="toDate"
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <DatePicker
                  required={true}
                  label={t('ServiceInquiry:ToDate')}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  maxDate={new Date()}
                  maxDateMessage={t('message:MS990032')}
                  minDate={undefined}
                  minDateMessage={''}
                  errorMessage={error?.message}
                />
              )}
            />
          </SectionCol>
        </SectionRow>
        <SectionRow sectionStyles={sharedStyle.secondLine}>
          <SectionCol>
            <Controller
              control={base.control}
              name="policyNumber"
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <Input
                  title={t('PolicyNumber')}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              )}
            />
          </SectionCol>
          <SectionCol>
            <Controller
              control={base.control}
              name="status"
              render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
                <SelectSearch
                  label={t('Status')}
                  options={[]}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  popupIcon={<assets.ArrowDownDropdownIcon />}
                  placeholder={t('common:Select')}
                />
              )}
            />
          </SectionCol>
          <SectionCol>
            <Controller
              control={base.control}
              name="transactionID"
              render={({ field: { value, onChange, onBlur } }) => (
                <Input
                  title={t('Transaction ID')}
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                />
              )}
            />
          </SectionCol>
        </SectionRow>
        <View style={importDetailStyles.searchContainer}>
          <TouchableOpacity style={[sharedStyle.button, sharedStyle.btnRed, importDetailStyles.searchButton]} onPress={() => onSearchEvent()}>
            <Text style={sharedStyle.textButtonRed}>{t('Search')}</Text>
          </TouchableOpacity>
        </View>
      </SectionContent>
      <CheckboxTable
        displayedColumns={displayedColumns}
        dataSource={dataSource}
        stickyHeader
        isPagination={true}
        totalRecord={total}
        pageSize={pageSize}
        pageNum={pageNum}
        setPageNum={setPageNum}
        setPageSize={setPageSize}
        setTotalRecord={setTotal}
        rowsPerPageOptions={[10, 25, 50, 100]}
        // onPageChange={onPageChange}
        // onRowsPerPageChange={onRowsPerPageChange}
        sortItem={sortItem}
        setSortItem={setSortItem}
      />
    </ScrollView>
  )
}
const importDetailStyles = StyleSheet.create({
  searchContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  searchButton: {
    marginLeft: 0,
    marginTop: 20,
    marginBottom: 0
  }
})